// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"98":"cdf061fd","365":"96d51736","750":"0774afb7"}[chunkId] + ".js";
};